import { LANGUAGES } from '@basehub/shared-constants'

export const prettierAllowedLanguages: Array<keyof typeof LANGUAGES> = [
  'javascript',
  'typescript',
  'tsx',
  'jsx',
  'json',
  'html',
]

export const format = async (
  code: string,
  language: (typeof prettierAllowedLanguages)[number]
) => {
  const [
    prettierTsPlugin,
    prettierHTMLPlugin,
    prettierBabelPlugin,
    prettierEstreePlugin,
    prettier,
  ] = await Promise.all([
    // @ts-ignore
    import('prettier/plugins/typescript').then((module) => module.default),
    // @ts-ignore
    import('prettier/plugins/html').then((module) => module.default),
    // @ts-ignore
    import('prettier/plugins/babel').then((module) => module.default),
    // @ts-ignore
    import('prettier/plugins/estree').then((module) => module.default),
    // @ts-ignore
    import('prettier/standalone').then((module) => module.format),
  ])
  let parser: string = language
  switch (language) {
    case 'javascript':
    case 'jsx':
      parser = 'babel'
      break
    case 'typescript':
    case 'tsx':
      parser = 'typescript'
      break

    default:
      break
  }

  return (
    await prettier(code, {
      parser,
      plugins: [
        prettierEstreePlugin,
        prettierHTMLPlugin,
        prettierTsPlugin,
        prettierBabelPlugin,
      ],
      semi: false,
      printWidth: 64,
      htmlWhitespaceSensitivity: 'ignore',
    })
  ).trimEnd()
}
